<template>
  <v-dialog
    transition="scale-transition"
    origin="center center"
    max-width="520"
    v-model="dialogModel"
    content-class="deposit-withdraw-popup marketingPopup"
  >
    <v-card
      class="rounded-0 pa-7"
      :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'"
    >
      <v-card-title class="pb-3 text-left justify-start pl-3">
        MAM Wallet Transfer
      </v-card-title>
      <v-card-subtitle class="mt-0 pl-3 pb-0 pr-10 text--ash">
        Transfer money from the selected {{ walletLabel }}
      </v-card-subtitle>

      <v-tabs
        v-model="activeTab"
        background-color="transparent"
        class="wallet-transfer-tabs px-3 mt-3"
        grow
        :color="$vuetify.theme.dark ? 'white' : '#039de9'"
        slider-color="greenMain"
      >
        <v-tab>Withdraw</v-tab>
        <v-tab>Internal Transfer</v-tab>
      </v-tabs>

      <v-card
        class="deposit-form px-3 py-4"
        :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'"
      >
        <v-tabs-items v-model="activeTab" class="transparent">
          <v-tab-item>
            <v-row>
              <v-col cols="12">
                <fieldset>
                  <legend>Source Wallet*</legend>
                  <v-text-field
                    :value="sourceWalletText"
                    single-line
                    solo
                    readonly
                    hide-details
                    class="custom-select"
                  />
                </fieldset>
              </v-col>
              <v-col cols="12">
                <fieldset>
                  <legend>Payment Method*</legend>
                  <v-text-field
                    value="Custom Withdraw"
                    single-line
                    solo
                    readonly
                    hide-details
                    class="custom-select"
                  />
                </fieldset>
              </v-col>
              <v-col cols="12">
                <fieldset>
                  <legend>Amount*</legend>
                  <v-text-field
                    v-model="withdrawForm.amount"
                    label="Enter Amount"
                    single-line
                    solo
                    hide-details
                    class="custom-select"
                  />
                </fieldset>
              </v-col>
              <v-col cols="12">
                <fieldset>
                  <legend>Remark</legend>
                  <v-text-field
                    v-model="withdrawForm.remarks"
                    label="Enter Remark"
                    single-line
                    solo
                    hide-details
                    class="custom-select"
                  />
                </fieldset>
              </v-col>
            </v-row>
          </v-tab-item>

          <v-tab-item>
            <v-row>
              <v-col cols="12">
                <fieldset>
                  <legend>From Wallet*</legend>
                  <v-text-field
                    :value="sourceWalletText"
                    single-line
                    solo
                    readonly
                    hide-details
                    class="custom-select"
                  />
                </fieldset>
              </v-col>
              <v-col cols="12">
                <fieldset>
                  <legend>To Trading Account*</legend>
                  <v-select
                    v-model="transferForm.to_trading_account_no"
                    solo
                    :items="tradingAcc"
                    item-text="text"
                    item-value="value"
                    append-icon="mdi-chevron-down"
                    label="Select Trading Account"
                    class="custom-select"
                    hide-details
                  />
                </fieldset>
              </v-col>
              <v-col cols="12">
                <fieldset>
                  <legend>Amount*</legend>
                  <v-text-field
                    v-model="transferForm.amount"
                    label="USD"
                    single-line
                    solo
                    hide-details
                    class="custom-select"
                  />
                </fieldset>
              </v-col>
              <v-col cols="12">
                <fieldset>
                  <legend>Remark</legend>
                  <v-text-field
                    v-model="transferForm.remarks"
                    label="Enter Remark"
                    single-line
                    solo
                    hide-details
                    class="custom-select"
                  />
                </fieldset>
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs-items>
      </v-card>

      <v-card-actions>
        <v-row dense>
          <v-col cols="12">
            <v-btn
              tile
              @click="submitForm"
              elevation="0"
              class="text-capitalize btn-account mr-3 px-sm-8"
              color="greenMain"
              :loading="transferLoading"
              :disabled="transferLoading"
            >
              Confirm
            </v-btn>
            <v-btn
              tile
              color="#FF567F"
              @click="closeModal"
              elevation="0"
              class="text-capitalize btn-account px-sm-8"
              :disabled="transferLoading"
            >
              Cancel
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { MAMWALLET__ACTIONS, REGISTERUSERDETAILS__ACTIONS } from "@/store/action-types";
import toast from "@/services/Notification";

export default {
  name: "MamWalletTransferModal",

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    selectedWallet: {
      type: Object,
      default: null,
    },
    walletType: {
      type: String,
      default: "manager",
    },
    walletOptions: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      activeTab: 0,
      withdrawForm: {
        amount: "",
        remarks: "",
      },
      transferForm: {
        to_trading_account_no: null,
        amount: "",
        remarks: "",
      },
    };
  },

  computed: {
    ...mapState("mamwallet", ["transferLoading"]),
    ...mapState("reguserdetails", ["tradingAcc"]),

    dialogModel: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },

    walletLabel() {
      return this.walletType === "investor" ? "Investor Wallet" : "Manager Wallet";
    },

    availableBalanceField() {
      return this.walletType === "investor"
        ? "investor_available_balance"
        : "manager_available_balance";
    },

    sourceBalance() {
      return Number(this.selectedWallet?.[this.availableBalanceField] || 0);
    },

    sourceWalletText() {
      if (!this.selectedWallet) return "";
      return `${this.selectedWallet.name || "N/A"} (${this.selectedWallet.client_account_id}) - ${this.sourceBalance.toFixed(2)} USD`;
    },

  },

  watch: {
    async value(isOpen) {
      if (isOpen) {
        await this.fetchClientTradingAccounts();
      } else {
        this.resetForms();
      }
    },
    async selectedWallet() {
      if (this.value) {
        await this.fetchClientTradingAccounts();
      }
    },
  },

  methods: {
    ...mapActions("mamwallet", [
      MAMWALLET__ACTIONS.CREATEMAMWALLETWITHDRAW,
      MAMWALLET__ACTIONS.CREATEMAMWALLETINTX,
    ]),
    ...mapActions("reguserdetails", [
      REGISTERUSERDETAILS__ACTIONS.CLIENTTRADINGACCOUNTS,
    ]),

    async fetchClientTradingAccounts() {
      if (!this.selectedWallet?.client_account_id) return;
      await this[REGISTERUSERDETAILS__ACTIONS.CLIENTTRADINGACCOUNTS](
        this.selectedWallet.client_account_id
      );
    },

    validateAmount(amount) {
      const parsedAmount = Number(amount);

      if (!this.selectedWallet) {
        toast.error("Selected wallet is required");
        return false;
      }

      if (!Number.isFinite(parsedAmount) || parsedAmount <= 0) {
        toast.error("Amount must be a valid positive number");
        return false;
      }

      if (parsedAmount > this.sourceBalance) {
        toast.error("Amount cannot exceed available balance");
        return false;
      }

      return true;
    },

    async submitForm() {
      if (this.activeTab === 0) {
        await this.submitWithdraw();
        return;
      }

      await this.submitInternalTransfer();
    },

    async submitWithdraw() {
      if (!this.validateAmount(this.withdrawForm.amount)) return;

      const payload = {
        wallet_id: this.selectedWallet.id,
        wallet_type: this.walletType,
        amount: this.withdrawForm.amount,
        remarks: this.withdrawForm.remarks,
        payment_method: "Custom Withdraw",
      };

      try {
        await this[MAMWALLET__ACTIONS.CREATEMAMWALLETWITHDRAW](payload);
        this.handleSuccess();
      } catch (_) {}
    },

    async submitInternalTransfer() {
      if (!this.transferForm.to_trading_account_no) {
        toast.error("Destination trading account is required");
        return;
      }

      if (!this.validateAmount(this.transferForm.amount)) return;

      const payload = {
        from_wallet_id: this.selectedWallet.id,
        to_trading_account_no: this.transferForm.to_trading_account_no,
        wallet_type: this.walletType,
        amount: this.transferForm.amount,
        remarks: this.transferForm.remarks,
      };

      try {
        await this[MAMWALLET__ACTIONS.CREATEMAMWALLETINTX](payload);
        this.handleSuccess();
      } catch (_) {}
    },

    handleSuccess() {
      this.$emit("success");
      this.closeModal();
    },

    closeModal() {
      this.dialogModel = false;
    },

    resetForms() {
      this.activeTab = 0;
      this.withdrawForm = {
        amount: "",
        remarks: "",
      };
      this.transferForm = {
        to_trading_account_no: null,
        amount: "",
        remarks: "",
      };
    },
  },
};
</script>

<style scoped>
.wallet-transfer-tabs {
  border-bottom: 1px solid rgba(120, 145, 170, 0.35);
  margin-bottom: 14px;
}

.wallet-transfer-tabs ::v-deep .v-tab {
  color: #6c8098;
  font-weight: 700;
  letter-spacing: 0;
  min-height: 40px;
  text-transform: none;
}

.wallet-transfer-tabs ::v-deep .v-tab--active {
  color: #039de9;
}

.theme--dark .wallet-transfer-tabs ::v-deep .v-tab {
  color: #b4c2d1;
}

.theme--dark .wallet-transfer-tabs ::v-deep .v-tab--active {
  color: #ffffff;
}
</style>
